import { ViewportScroller } from '@angular/common';
import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, Scroll } from '@angular/router';
import { filter, map, mapTo, withLatestFrom } from 'rxjs/operators';

/**
 * @description Custom Navigation Scroller
 * @export
 * @class RouterScrollService
 */
@Injectable({
  providedIn: 'root',
})
export class RouterScrollService {
  private previousUrl: string;

  constructor(
    router: Router,
    viewportScroller: ViewportScroller,
    route: ActivatedRoute
  ) {
    const scrollEvents$ = router.events.pipe(
      filter((event) => event instanceof Scroll),
      map((event) => event as Scroll)
    );

    const targetRoute = router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      mapTo(route),
      map((r) => {
        while (r.firstChild) {
          r = r.firstChild;
        }
        return r;
      })
    );
    scrollEvents$
      .pipe(withLatestFrom(targetRoute))
      .subscribe(([scrollEvent, routeEvent]) => {
        const data = routeEvent.snapshot.data;

        if (scrollEvent.position) {
          // backward navigation
          viewportScroller.scrollToPosition(scrollEvent.position);
        } else if (scrollEvent.anchor) {
          // anchor navigation
          viewportScroller.scrollToAnchor(scrollEvent.anchor);
        } else if (router.url.split(/[?#]/)[0] === this.previousUrl) {
          return;
        } else if (!data.disableScrollTop) {
          viewportScroller.scrollToPosition([0, 0]);
        }

        this.previousUrl = router.url.split(/[?#]/)[0];
      });
  }
}
